<div class="business-account-request">
  <div class="business-account-request--section-top">
    <div class="business-account-requestt--header">
      <h1 tabindex="0">{{pageTitle}}</h1>
    </div>
    <hr />
  </div>
  <div>
    <div class="section-bottom--tab-container">
      <mat-tab-group (selectedTabChange)="updateTabView($event)" [(selectedIndex)]="tabIndex">
        <mat-tab [label]="businessAccount"  ></mat-tab>
        <mat-tab [label]="inviteUsers"> </mat-tab>
      </mat-tab-group>
    </div> 
    <ng-container *ngIf="activeTab === inviteUsers">
      <div class="row">
        <div class="col-12">
          <tmhna-portal-invite-users></tmhna-portal-invite-users>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === businessAccount">
      <div class="row">
        <div class="col-12">
          <tmhna-portal-business-account-request></tmhna-portal-business-account-request>
        </div>
      </div>
    </ng-container>
  </div>
</div>